import React, { useEffect, useState } from "react";
import { cloneDeep } from "lodash";
import { Row, Col } from "reactstrap";
import NodeNameValidation from "../../atoms/node-name-validation";
import AttributeCard from "../attribute-card";
import HelpTooltip from "../../atoms/help-tooltip";
import { t } from "../../../utils/utils";
export default function NodeDatabaseProperty({
  node,
  nodeChange,
  dependencies
}) {
  const [attributes, setAttributes] = useState([]);

  useEffect(() => {
    if (node.properties && node.properties.attributes.length > 0) {
      setAttributes(node.properties.attributes);
    } else {
      const primaryKeyAttribute = {
        name: "id",
        type: "String",
        primaryKey: true,
        size: 100,
        notNull: true
      };
      setAttributes([primaryKeyAttribute]);
    }
  }, [node]);
  const onUpdateAttributes = (data, index) => {
    const tmp = cloneDeep(attributes);
    tmp[index] = data;
    setAttributes(tmp);
  };
  const addAttribute = data => {
    const tmp = cloneDeep(attributes);
    tmp.push(data);
    setAttributes(tmp);
  };
  const onDeleteAttribute = index => {
    const tmp = cloneDeep(attributes);
    tmp.splice(index, 1);
    setAttributes(tmp);
  };

  const onSubmit = name => {
    const tmp = cloneDeep(node);
    tmp.properties.name = name;
    tmp.properties.attributes = attributes;
    nodeChange(tmp);
  };
  return (
    <>
      <Row>
        <Col>
          <NodeNameValidation
            label="modalPropiedadesLabelModeloValidacionNombre"
            feedback="modalPropiedadesFeedbackValidacionNombre"
            nodesNames={dependencies.nodeNames}
            oldName={node.properties.name}
            onSubmit={onSubmit}
            inputProps={{
              disabled: node.properties.name
                ? node.properties.name.length > 0
                : false
            }}
          />
          <AttributeCard
            formTitle={t("modalPropiedadesTituloFormModelo")}
            resultsTitle={t("modalPropiedadesTituloTablaModelo")}
            attributes={attributes}
            updateAttribute={onUpdateAttributes}
            addAttribute={addAttribute}
            deleteAttribute={onDeleteAttribute}
            columns={[
              {
                name: t("modalPropiedadesCampoNombre"),
                label: t("modalPropiedadesCampoNombre"),
                key: "name",
                type: "text",
                required: true,
                cols: 3,
                tooltip: (
                  <HelpTooltip msg={t("modalPropiedadesCampoNombreTooltip")} />
                )
              },
              {
                name: t("modalPropiedadesCampoTipo"),
                label: t("modalPropiedadesCampoTipo"),
                key: "type",
                type: "select",
                options: {
                  string: "String",
                  int: "Int",
                  boolean: "Boolean",
                  float: "Float"
                },
                required: true,
                cols: 2,
                tooltip: (
                  <HelpTooltip msg={t("modalPropiedadesCampoTipoTooltip")} />
                )
              },
              {
                name: t("modalPropiedadesCampoClave"),
                label: t("modalPropiedadesCampoClave"),
                key: "primaryKey",
                type: "switch",
                index: true,
                cols: 2,
                tooltip: (
                  <HelpTooltip msg={t("modalPropiedadesCampoClaveTooltip")} />
                )
              },
              {
                name: t("modalPropiedadesCampoLargo"),
                label: t("modalPropiedadesCampoLargo"),
                key: "size",
                type: "number",
                cols: 2,
                tooltip: (
                  <HelpTooltip msg={t("modalPropiedadesCampoLargoTooltip")} />
                )
              },
              {
                name: t("modalPropiedadesCampoObligatorio"),
                label: t("modalPropiedadesCampoObligatorio"),
                key: "notNull",
                type: "switch",
                cols: 2,
                tooltip: (
                  <HelpTooltip
                    msg={t("modalPropiedadesCampoObligatorioTooltip")}
                  />
                )
              }
            ]}
          />
        </Col>
      </Row>
    </>
  );
}
